import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import BasicDateRangePicker from "../Controls/DateRange/BasicDateRangePicker";
import SearchBar from "../Controls/SearchBar/SearchBar";
import Button from "../../components/Controls/Buttons/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import "./actionBars.scss";
import { Badge, Divider, Grid, IconButton } from "@mui/material";
import { action } from "../../constants/action";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
// import { preProRoutes } from "../../routes/routeConstants";

export default function ActionBar(props) {
  const navigate = useNavigate();
  const {
    // steps,
    onSearch,
    searchText,
    filterByDate,
    clear,
    onClickViewPendingBatches,
    list,
    diasableBatchOptions = false,
    drugType,
    setDrugType,
    setSearchText,
    approvalFor,
  } = props;

  const createNewProject = () => {
    // navigate("/new-project");
    // navigate(`/${preProRoutes.newProject}`);
  };

  return (
    <Box className="action-bar">
      <AppBar className="actionbar-bg">
        {/* {steps !== "steppers" ? ( */}
        <Toolbar>
          <Grid container className="action-wrap">
            <Grid item md={6}>
              <SearchBar
                onSearch={(value, type) => onSearch(value, type)}
                diasableBatchOptions={diasableBatchOptions}
                searchText={searchText}
                drugType={drugType}
                setDrugType={setDrugType}
                setSearchText={setSearchText}
              />
            </Grid>

            {/* <Divider
              orientation="vertical"
              flexItem
              sx={{
                m: "4px 20px",
                width: "2px",
                backgroundColor: "#d3d3d3", // Optional: darker color for visibility
                borderRadius: "2px", // Optional: rounded edges
              }}
            /> */}

            <Grid item md={6}>
              <BasicDateRangePicker
                filterByDate={filterByDate}
                clear={clear}
                diasableBatchOptions={diasableBatchOptions}
                approvalFor={approvalFor}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
